















import {
  Vue,
  Component,
  Prop
} from "@/shared/vuepack";
import { Location } from "vue-router";
@Component
export default class ProgressIndicator extends Vue {

  @Prop()
  items: object[];

  @Prop()
  selectedIndex: number;

  @Prop()
  explicitSteps: boolean;

  @Prop()
  outsideHeader: boolean;

  @Prop()
  itemLink: (index: number) => string | Location;

  @Prop()
  maxAllowedClickIndex: number;

  @Prop()
  disabledLinks: boolean;

  disableClick (index: number) {
    if (this.disabledLinks) {
      return false;
    }

    return (typeof(this.maxAllowedClickIndex) !== "undefined") && index > this.maxAllowedClickIndex;
  }

  isSelected (index) {
    return this.selectedIndex === index;
  }

  isComplete (index) {
    return this.selectedIndex > index;
  }

  getItemLink (index: number) {
    if (this.itemLink) {
      return this.itemLink(index);
    }

    return `/onboarding/${index}`;
  }
}

